export enum SpinnerPositionType {
    Center,
    Top,
    Bottom,
}
